"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageUiSchema = void 0;
const json_schema_keys_1 = require("../json_schema_keys");
const schema_object_1 = require("./schema_object");
class PageUiSchema extends schema_object_1.SchemaObject {
    constructor(uiOrder) {
        super();
        this.uiOrder = uiOrder;
    }
    get uiOrder() {
        return this[json_schema_keys_1.JsonSchemaKeys.UI_ORDER_KEY];
    }
    set uiOrder(uiOrder) {
        this[json_schema_keys_1.JsonSchemaKeys.UI_ORDER_KEY] = uiOrder;
    }
    indexOfField(field) {
        return this.uiOrder.indexOf(field.uniqueKey());
    }
    addFields(fields) {
        for (const field of fields) {
            if (field.hasUiSchema) {
                this[field.uniqueKey()] = field.uiSchema();
            }
            if (field.clearValueOnClone) {
                this.addDeleteInputs([field.uniqueKey()]);
            }
            if (field.sortable) {
                this.addSortableFields([field.uniqueKey()]);
            }
        }
    }
    addDeleteInputs(fieldKeys) {
        if (!Array.isArray(fieldKeys) || fieldKeys.length === 0) {
            return;
        }
        const onClone = this.ensureOnCloneSchema();
        const existing = Array.isArray(onClone[json_schema_keys_1.JsonSchemaKeys.UI_DELETE_INPUTS_KEY])
            ? onClone[json_schema_keys_1.JsonSchemaKeys.UI_DELETE_INPUTS_KEY]
            : [];
        onClone[json_schema_keys_1.JsonSchemaKeys.UI_DELETE_INPUTS_KEY] = Array.from(new Set([...existing, ...fieldKeys]));
    }
    addSortableFields(fieldKeys) {
        if (!Array.isArray(fieldKeys) || fieldKeys.length === 0) {
            return;
        }
        const existing = Array.isArray(this[json_schema_keys_1.JsonSchemaKeys.UI_SORTABLE_KEY])
            ? this[json_schema_keys_1.JsonSchemaKeys.UI_SORTABLE_KEY]
            : [];
        this[json_schema_keys_1.JsonSchemaKeys.UI_SORTABLE_KEY] = Array.from(new Set([...existing, ...fieldKeys]));
    }
    ensureOnCloneSchema() {
        if (!(this[json_schema_keys_1.JsonSchemaKeys.UI_ON_CLONE_KEY] instanceof schema_object_1.SchemaObject)) {
            this[json_schema_keys_1.JsonSchemaKeys.UI_ON_CLONE_KEY] = new schema_object_1.SchemaObject();
        }
        return this[json_schema_keys_1.JsonSchemaKeys.UI_ON_CLONE_KEY];
    }
}
exports.PageUiSchema = PageUiSchema;
